<i *ngIf="value" class="tp-primary-icon fa fa-check"></i>
